import { Action } from '@ngrx/store';

export const UPSERT = '[ORDER INFORMATION] DELIVERY UPSERT';
export const CLEAR = '[ORDER INFORMATION] DELIVERY CLEAR';

export class Upsert implements Action {
    readonly type = UPSERT;
    constructor(public payload: any) {
    }
}

export class Clear implements Action {
    readonly type = CLEAR;
    constructor() {
    }
}

export type DeliveryActions = Upsert
| Clear;


